import { isMobile } from 'hooks';
import { ButtonColors } from 'types';
import { Flex } from 'components/flex';
import { Icon } from 'components/icon';
import { Config, AppRoutes } from 'config';
import { Button } from 'components/button';
import { InfoBlock } from 'components/info-block';
import { TotalCart } from 'components/total-cart';
import { joinRoutes, formatPrice } from 'utils/helpers';
import { SendReceiptDialog } from 'components/send-receipt-dialog';
import { ProductSummaryList } from 'components/product-summary-list';

import { ExchangeDetailsProps } from './types';

const { Home, Receipts } = AppRoutes.Products;

export const ExchangeDetails = ({ data }: ExchangeDetailsProps) => {
  const mobile = isMobile();

  if (!data?.exchanges?.length) {
    return null;
  }

  return data?.exchanges?.map((value) => {
    const itemsWithoutExchange = value?.items?.filter(
      (item) => !item.isExchange
    );

    return (
      <InfoBlock key={value.id} title={`Exchange #${value.id}`}>
        <Flex column gap={24}>
          <Flex column gap={8}>
            <p>
              <b>Total Exchange Amount:</b>{' '}
              {formatPrice(value.exchangeItemsAmount)}
            </p>

            <p>
              <b>Total Replacement Amount:</b>{' '}
              {formatPrice(
                itemsWithoutExchange?.reduce(
                  (acc, item) => acc + +item.price * item.quantity,
                  0
                )
              )}
            </p>

            <p>
              <b>Return to inventory:</b>{' '}
              {value?.isReturnToInventory ? 'Yes' : 'No'}
            </p>
          </Flex>

          <ProductSummaryList
            isExchange
            title="Return Products:"
            values={value?.items?.filter((item) => item.isExchange)}
          />

          <ProductSummaryList
            title="Exchange Products:"
            values={itemsWithoutExchange}
          />

          <TotalCart
            data={value}
            tip={value?.tip}
            eventTax={value?.tax}
            paymentMethods={value.paymentMethods}
            companyProcessingFees={value?.processingFees}
            shippingPrice={Number(value?.shippingPrice || 0)}
          />

          <Flex gap={16} column={mobile}>
            <SendReceiptDialog data={value} />

            <Button
              text="Print"
              fullWidth={mobile}
              icon={<Icon.Printer />}
              disabled={!value?.pdfUrl}
              colorType={ButtonColors.LightBlue}
              onClick={() => window.open(value?.pdfUrl, '_blank')}
            />

            {Config.isDebugHTMLEnabled && (
              <Button
                text="View HTML"
                to={joinRoutes(
                  [Home, Receipts.Home, Receipts.Details, Receipts.HTML],
                  {
                    id: data.eventId,
                    receiptId: value.id,
                  }
                )}
              />
            )}
          </Flex>
        </Flex>
      </InfoBlock>
    );
  });
};
